import Typography from "typography"
import twinPeaksTheme from "typography-theme-twin-peaks"

const typography = new Typography(twinPeaksTheme)

export default typography




// WEBPACK FOOTER //
// ./src/utils/typography.js